import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import './MemberSelect.scss'

const MemberSelect = ({
  placeholder = '개인',
  value,
  teamUsers = [],
  onChange,
  isActive = false,
  setSelectedMember,
  setActiveLevel,
  currentUser = null,
  userAuth = null,
  currentTeamName = null,
  /** 팀 라우트(false) vs 개인 라우트(true). 팀일 때 버튼 클릭=본인으로 이동, 개인일 때 버튼 클릭=드롭다운 */
  isOnIndividualRoute = false,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef(null)
  const selectedUser = teamUsers.find((user) => user.id === value)

  // 본인 팀인지 아닌지 판단
  let isMyTeam
  if (userAuth?.teamName && currentTeamName) {
    isMyTeam = userAuth.teamName === currentTeamName
  } else {
    isMyTeam =
      currentUser && teamUsers.some((user) => user.id === currentUser.id)
  }

  // 개인 혹은 본인 이름 표기용
  let displayText
  if (selectedUser) {
    displayText = selectedUser.name
  } else {
    // value가 없으면 항상 placeholder 표시
    displayText = placeholder
  }

  // 같은 팀일 때만 currentUser를 선택된 것으로 간주
  const effectiveValue = value || (isMyTeam ? currentUser?.id : null)

  const handleClose = useCallback(() => {
    setIsOpen(false)
  }, [])

  // 외부 클릭 감지
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        handleClose()
      }
    }

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isOpen, handleClose])

  const handleButtonClick = (e) => {
    e.stopPropagation()
    //   // 개인 라우트: 버튼 클릭 = 드롭다운 열기
    //   if (isOnIndividualRoute) {
    //     setIsOpen(true)
    //     return
    //   }
    //   // 팀 라우트: 버튼 클릭 = 본인으로 바로 이동 (내 팀일 때만), 아니면 드롭다운
    //   if (isMyTeam && currentUser?.id) {
    //     if (onChange) {
    //       onChange(currentUser.id)
    //     } else {
    //       setActiveLevel('MEMBER')
    //       const myUser = teamUsers.find((u) => u.id === currentUser?.id)
    //       if (myUser) setSelectedMember(myUser)
    //       else setSelectedMember(currentUser)
    //     }
    //   } else {
    //     setIsOpen(true)
    //   }
    // }

    // const handleArrowClick = (e) => {
    //   e.stopPropagation()
    //   // 화살표 클릭: 드롭다운만 토글 (선택하기 전까지 active 상태로 바꾸지 않음)
    //   if (isOpen) {
    //     handleClose()
    //   } else {
    //     setIsOpen(true)

    const openDropdown = () => setIsOpen(true)

    if (isActive) {
      if (isOpen) {
        handleClose()
      } else {
        openDropdown()
      }
      return
    }

    // 비활성 상태
    if (isMyTeam) {
      setActiveLevel('MEMBER')

      const myUser =
        teamUsers.find((u) => u.id === currentUser?.id) ?? currentUser
      setSelectedMember(myUser)
    }

    openDropdown()
  }

  const handleUserSelect = (user) => {
    setSelectedMember(user)
    setActiveLevel('MEMBER')
    handleClose()
    if (onChange) {
      onChange(user.id)
    }
  }

  const buttonClassName = `member-select-button ${isActive ? 'active' : ''} ${isOpen ? 'open' : ''}`
  const isPlaceholder = displayText === placeholder
  const nameClassName = `member-select-button-name ${isMyTeam ? 'my-team' : 'my-team'} ${isPlaceholder ? 'placeholder' : ''}`

  return (
    <div ref={dropdownRef} className="member-select">
      <div className={buttonClassName} onClick={handleButtonClick}>
        <span className={nameClassName}>{displayText}</span>
        <span className="member-select-button-arrow">
          {isOpen ? <CaretUpOutlined /> : <CaretDownOutlined />}
        </span>
      </div>

      {isOpen && (
        <div className="member-select-dropdown">
          <div className="member-select-dropdown-header">
            팀원을 선택해주세요
          </div>
          <div className="member-select-dropdown-options">
            {teamUsers.map((user) => {
              const isSelected = user.id === effectiveValue
              return (
                <div
                  key={user.id}
                  onClick={() => handleUserSelect(user)}
                  className={`member-select-dropdown-option ${isSelected ? 'selected' : ''}`}
                >
                  <span>{user.name}</span>
                </div>
              )
            })}
          </div>
        </div>
      )}
    </div>
  )
}

export default MemberSelect
